import {
  type GenericMappingByKey,
  GenericMappingType,
} from '../../search/types'

export const ZENDESK_GENERIC_MAPPINGS_BY_KEY = Object.freeze({
  status: {
    type: GenericMappingType.KEYWORD,
    name: 'Status',
    description: 'The status of the ticket',
    enumFromCollapseEsQuery: true,
    order: 0,
  },
  priority: {
    type: GenericMappingType.KEYWORD,
    name: 'Priority',
    description: 'The priority of the ticket',
    enum: ['urgent', 'high', 'normal', 'low'],
    order: 1,
  },
  type: {
    type: GenericMappingType.KEYWORD,
    name: 'Type',
    description: 'The type of the ticket',
    enum: ['problem', 'incident', 'question', 'task'],
    order: 2,
  },
  assignee: {
    type: GenericMappingType.KEYWORD,
    name: 'Assignee',
    description: 'The agent assigned to the ticket',
    enumFromCollapseEsQuery: true,
    order: 3,
  },
  requester: {
    type: GenericMappingType.KEYWORD,
    name: 'Requester',
    description: 'The user who requested the ticket',
    enumFromCollapseEsQuery: true,
    order: 4,
  },
  group: {
    type: GenericMappingType.KEYWORD,
    name: 'Group',
    description: 'The group assigned to the ticket',
    enumFromCollapseEsQuery: true,
    order: 5,
  },
  tags: {
    type: GenericMappingType.KEYWORD,
    name: 'Tags',
    description: 'The tags associated with the ticket',
    enumFromTermsAggEsQuery: true,
    order: 6,
  },
} satisfies GenericMappingByKey)
